import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteConfirmModal from "../../common/crud/DeleteConfirmModal";
import EntityTableCard from "../../common/crud/EntityTableCard";
import Pen from "../../assets/images/pen.svg";
import DeleteIMG from "../../assets/images/trash.svg";
import PasswordImg from "../../assets/images/password-edit.svg";
import useUser from "../../hooks/store/user";

export const CustomersTable = ({
  count = 0,
  items = [],
  onPageChange = () => {},
  onRowsPerPageChange,
  page = 0,
  rowsPerPage = 10,
  selected = [],
}) => {
  const navigate = useNavigate();
  const { updateUserDataAction } = useUser();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleDeleteUser = async () => {
    setIsDeleteModalOpen(false);

    await updateUserDataAction({
      id: selectedUser?.id,
      name: selectedUser?.name,
      status: "Deactive",
    });
  };

  const columns = useMemo(
    () => [
      {
        id: "serial",
        label: "S.No",
        render: (_, { rowNumber }) => rowNumber,
      },
      {
        id: "name",
        key: "name",
        label: "Name",
      },
      {
        id: "id",
        key: "id",
        label: "Id",
      },
      {
        id: "email",
        key: "email",
        label: "Email",
      },
      {
        id: "role",
        key: "roleName",
        label: "Role",
      },
      {
        id: "action",
        align: "center",
        label: "Action",
        width: "100px",
        render: (userItem) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "80px",
            }}
          >
            <Box
              component="img"
              src={Pen}
              alt="pen"
              onClick={() =>
                navigate("/edit/users", {
                  state: { users: userItem },
                })
              }
              sx={{ cursor: "pointer" }}
            />
            <Box
              component="img"
              src={DeleteIMG}
              alt="DeleteIMG"
              onClick={() => {
                setSelectedUser(userItem);
                setIsDeleteModalOpen(true);
              }}
              sx={{
                cursor: "pointer",
                height: "20px",
              }}
            />
            <Box
              component="img"
              src={PasswordImg}
              alt="passwordImg"
              onClick={() =>
                navigate("/user/updatepassword", {
                  state: { users: userItem },
                })
              }
              sx={{
                cursor: "pointer",
                height: "20px",
              }}
            />
          </Box>
        ),
      },
    ],
    [navigate]
  );

  return (
    <>
      <EntityTableCard
        columns={columns}
        count={count}
        headSx={{ position: "sticky", top: 0 }}
        items={items}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        selected={selected}
      />
      <DeleteConfirmModal
        message=" Are you sure you want to delete this user?"
        onCancel={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDeleteUser}
        open={isDeleteModalOpen}
      />
    </>
  );
};

CustomersTable.propTypes = {
  count: PropTypes.number,
  items: PropTypes.array,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
